import { EnglishStr } from "@/lib/EnglishStr";
import ErrorTemplate from "./ErrorTemplate";

export default function JointNotEligible() {
  
  return (
    <ErrorTemplate
      title="Sorry, we cannot proceed to your application."
      content={"We regret to inform you that your application doesn't meet our requirements for opening a mortgage. Please visit your nearest branch or call our Contact Centre at " + EnglishStr.ContactCentrePhone + " for assistance."}
    />
  );
}
